import React from 'react';
import {Typography } from '@mui/material';
import { tipoDeMedio } from 'constantes/globalsStates';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import DetalleDeLaPantalla from './DetalleDeLaPantalla';
import DetalleDeLaVallaFija from './DetalleDeLaVallaFija';
import DetalleDeLaVallaMovil from './DetalleDeLaVallaMovil';

const DetalleDeLosMediosAlternativos = ({title, openFullScreenDialog, handleClose, datosDelMedio, datosDelMedioSeleccionado, datosDelQRMovil}) => {
  const {tipoDeMedioDeComunicacion} = datosDelMedio;

  const validarTipoDeMedio = () => {
    switch (tipoDeMedioDeComunicacion.id) {
      case tipoDeMedio["pantallas"]: return ( <DetalleDeLaPantalla datosDelMedioSeleccionado={datosDelMedioSeleccionado} /> )
      case tipoDeMedio["vallasFijas"]: return ( <DetalleDeLaVallaFija datosDelMedioSeleccionado={datosDelMedioSeleccionado} /> )
      case tipoDeMedio["vallasMoviles"]: return ( <DetalleDeLaVallaMovil datosDelMedioSeleccionado={datosDelMedioSeleccionado} datosDelQRMovil={datosDelQRMovil} /> )
      default: return <Typography align='center' variant='h3' >SIN DETALLE DEL MEDIO</Typography>
    }
  }

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={handleClose}
      title={title}
      fullscreen={true}
      showButtonClose={false}
      showIconButton={true}
    >
      {validarTipoDeMedio()}
    </DialogoPantallaCompleta>
  );
}

export default DetalleDeLosMediosAlternativos;